export default __webpack_public_path__ + "static/media/track.f4793e8f.png";